export abstract class ErrorCodesService {
  abstract getError(validation: string, fieldName: string): string;
}
